import { render } from "./MemberTypeSelector.vue?vue&type=template&id=bb726880&scoped=true"
import script from "./MemberTypeSelector.vue?vue&type=script&lang=js"
export * from "./MemberTypeSelector.vue?vue&type=script&lang=js"

import "./MemberTypeSelector.vue?vue&type=style&index=0&id=bb726880&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb726880"]])

export default __exports__